

import { Typography } from '@mui/material';
import React,{useEffect,useState} from 'react';
import HeroSection from './HeroSection'
import AboutHistory from './AboutHistory'
import LuluaPresence from './LuluaPresence'
import PartnerSlider from './PartnerSlider'
import AssetManagementPage from './AssetManagementPage'
import OrgStructure3D from './OrgStructure3D'
import Team from './Team'

function About() {


  

   

  return (
    <div className="App">
  <HeroSection/>
  <AboutHistory/>
   <LuluaPresence/>
   <AssetManagementPage/>
   <OrgStructure3D/>
   <Team/>

   <PartnerSlider/>

    </div>
  );
}

export default About;
